import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom"; // 👈 Import useLocation
import apiClient from "../services/apiClient";
import { useTheme } from '../config/ThemeContext';

function Schedule() {
  const { seasonId } = useParams();
  const location = useLocation(); // 👈 Initialize useLocation
  const [scheduleHtml, setScheduleHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const colors = useTheme();

  // Helper function to extract query parameter
  const getTeamId = () => {
    const params = new URLSearchParams(location.search);
    return params.get('teamId');
  };
  
  const teamId = getTeamId(); // 👈 Get the teamId

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Construct the API URL, adding the teamId as a query parameter
        let apiUrl = `/api/seasons/${seasonId}/schedule`;
        if (teamId) {
          apiUrl += `?teamId=${teamId}`; // 👈 API now receives ?teamId=X
        }

        // Use apiClient which automatically includes the token
        const response = await apiClient.get(apiUrl, {
          responseType: 'text'
        });
        
        setScheduleHtml(response.data);
      } catch (err) {
        console.error('Failed to load schedule:', err);
        setError('Failed to load schedule report. Please make sure you are logged in.');
      } finally {
        setLoading(false);
      }
    };

    if (seasonId) {
      fetchSchedule();
    }
  }, [seasonId, teamId, location.search]); // 👈 Depend on teamId and location.search

  // --- [handleOpenInNewTab and handleDownloadPDF logic remains the same, but should also include teamId] ---
  
  const handleDownloadPDF = async () => {
    try {
      // 1. Construct the download URL with teamId
      let downloadUrl = `/api/seasons/${seasonId}/schedule/download`;
      if (teamId) {
          downloadUrl += `?teamId=${teamId}`; // 👈 Pass teamId to the download endpoint
      }
        
      // 2. Use apiClient to fetch with the token
      const response = await apiClient.get(
        downloadUrl, 
        { responseType: 'blob' }
      );
      
      // 3. Trigger the download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Schedule_Season_${seasonId}${teamId ? `_Team_${teamId}` : ''}.pdf`);
      document.body.appendChild(link);
      link.click();
      
      // 4. Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // Your existing error handling for download...
      console.error('Failed to download PDF:', err);
      alert('Failed to download PDF. Please try again.');
    }
  };

  if (loading) {
    // ... loading UI ...
  }
  
  if (error) {
    // ... error UI ...
  }
  
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Header with actions */}
      <div className="flex justify-between items-center mb-6 print:hidden">
        <h1 className={`text-2xl font-bold ${colors.neutral.text}`}>
          Season Schedule {teamId ? `(Team ${teamId})` : '(Full)'}
        </h1>
        <div className="flex gap-3">
          {/* handleOpenInNewTab implementation should be reviewed if you still use it */}
          {/* <button
            onClick={handleOpenInNewTab}
            className={`px-4 py-2 rounded-md ${colors.buttons.primary}`}
          >
            Open in New Tab
          </button> */}
          <button
            onClick={handleDownloadPDF}
            className={`px-4 py-2 rounded-md ${colors.buttons.primary}`}
          >
            Download PDF
          </button>
        </div>
      </div>
      {/* Report Content */}
      <div className="bg-white rounded-lg shadow-sm border p-6 overflow-auto">
        <div dangerouslySetInnerHTML={{ __html: scheduleHtml }} />
      </div>
    </div>
  );
}

export default Schedule;